/**
 * Configuración del módulo de Tickets
 * Cambiar aquí para afectar todos los componentes
 */

export const LOCALHOST = false;
